import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BookIcon, ClockIcon, VolumeIcon } from 'lucide-react';
export function StudyPreferences() {
  const {
    isArabic
  } = useLanguage();
  return <div className="space-y-8" data-id="element-1480">
      {/* Learning Goals */}
      <div data-id="element-1481">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1482">
          {isArabic ? 'أهداف التعلم' : 'Learning Goals'}
        </h3>
        <div className="space-y-4" data-id="element-1483">
          <div data-id="element-1484">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1485">
              {isArabic ? 'المستوى المستهدف' : 'Target Level'}
            </label>
            <select className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-1486">
              <option value="beginner" data-id="element-1487">
                {isArabic ? 'مبتدئ' : 'Beginner'}
              </option>
              <option value="intermediate" data-id="element-1488">
                {isArabic ? 'متوسط' : 'Intermediate'}
              </option>
              <option value="advanced" data-id="element-1489">
                {isArabic ? 'متقدم' : 'Advanced'}
              </option>
            </select>
          </div>
          <div data-id="element-1490">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1491">
              {isArabic ? 'الوقت المستهدف يومياً' : 'Daily Study Target'}
            </label>
            <select className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-1492">
              <option value="15" data-id="element-1493">15 {isArabic ? 'دقيقة' : 'minutes'}</option>
              <option value="30" data-id="element-1494">30 {isArabic ? 'دقيقة' : 'minutes'}</option>
              <option value="60" data-id="element-1495">60 {isArabic ? 'دقيقة' : 'minutes'}</option>
            </select>
          </div>
        </div>
      </div>
      {/* Learning Preferences */}
      <div data-id="element-1496">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1497">
          {isArabic ? 'تفضيلات التعلم' : 'Learning Preferences'}
        </h3>
        <div className="space-y-4" data-id="element-1498">
          <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900/50 rounded-lg" data-id="element-1499">
            <div className="flex items-center gap-3" data-id="element-1500">
              <VolumeIcon className="w-5 h-5 text-gray-500" data-id="element-1501" />
              <div data-id="element-1502">
                <div className="font-medium text-gray-900 dark:text-white" data-id="element-1503">
                  {isArabic ? 'نطق تلقائي' : 'Auto-pronunciation'}
                </div>
                <div className="text-sm text-gray-500" data-id="element-1504">
                  {isArabic ? 'تشغيل النطق تلقائياً للكلمات الجديدة' : 'Play pronunciation automatically for new words'}
                </div>
              </div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1505">
              <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1506" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" data-id="element-1507"></div>
            </label>
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900/50 rounded-lg" data-id="element-1508">
            <div className="flex items-center gap-3" data-id="element-1509">
              <BookIcon className="w-5 h-5 text-gray-500" data-id="element-1510" />
              <div data-id="element-1511">
                <div className="font-medium text-gray-900 dark:text-white" data-id="element-1512">
                  {isArabic ? 'عرض الترجمة' : 'Show Translation'}
                </div>
                <div className="text-sm text-gray-500" data-id="element-1513">
                  {isArabic ? 'عرض الترجمة العربية دائماً' : 'Always show Arabic translation'}
                </div>
              </div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1514">
              <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1515" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" data-id="element-1516"></div>
            </label>
          </div>
        </div>
      </div>
    </div>;
}